import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import config from '@plone/volto/registry';
import { isSlotAvailable } from 'mpf-slots-frontend/helpers';

/**
 * RNF06: a mesma coluna de leitura centralizada (8/12) que a Notícia já usa
 * (`_news-view.scss`, `--centered`) — Notícia nunca tem a sidebar de slots
 * (excluída em `ContentContainer.jsx`), então sempre centraliza; aqui a
 * página PODE ter uma sidebar (de slot, `asideLeftSlot`, ou a de
 * `relatedItems` nativo renderizada logo abaixo), então só centraliza
 * quando NENHUMA das duas está presente — senão o conteúdo ficaria
 * duplamente estreitado (8/12 de um espaço que já é 3/4 da página).
 *
 * O estado dos slots (`state.slots.data`) só fica correto depois que o
 * client termina de buscá-lo — durante o SSR e a primeira hidratação ele
 * ainda não reflete os componentes herdados de páginas ancestrais. Calcular
 * `hasLeftSlot` direto nesses dois momentos produz valores diferentes e um
 * warning de hydration mismatch no React (esperado e inofensivo — a mesma
 * assincronia que já existe na sidebar de slot do próprio
 * `ContentContainer.jsx`, que também só aparece depois desse carregamento).
 * `suppressHydrationWarning` NÃO deve ser usado aqui: nesta versão do
 * React/ReactDOM (18.2), ele impede a reconciliação de atualizar a
 * className do nó em renders posteriores — não só a hidratação inicial —
 * deixando a coluna sempre presa no valor do servidor. Confirmado ao vivo:
 * com o atributo, `--centered` nunca chegava a aparecer mesmo depois dos
 * dados carregarem; sem ele, a classe atualiza corretamente.
 *
 * Mora em arquivo próprio porque é compartilhado pelas duas molduras de
 * página: `InternalLayout` (página interna) e `SubHomeLayout` (sub-home).
 */
export function useHasSidebar(hasRelatedItems: boolean) {
  const pathname = useLocation().pathname;
  const slotData = useSelector((state: any) => state.slots?.data || {});
  const [isClient, setIsClient] = useState(false);

  useEffect(() => {
    setIsClient(true);
  }, []);

  const hasLeftSlot =
    isClient && config.slots?.asideLeftSlot
      ? isSlotAvailable({
          slotName: 'asideLeftSlot',
          pathname,
          slotData,
          slots: config.slots,
        })
      : true;

  return hasLeftSlot || hasRelatedItems;
}

export default useHasSidebar;
